'use strict';

var SeasonalityReviewLegendSidebar = function SeasonalityReviewLegendSidebar() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/seasonality-review-legend-sidebar.html'),
    scope: {
      legend: '='
    }
  };
};
SeasonalityReviewLegendSidebar.$inject = [];
module.exports = SeasonalityReviewLegendSidebar;